import React, { useState } from "react";

import { ConfirmOne } from "./StepConfirmNumber/ConnfirmNumberOne";
import { ConfirmTwo } from "./StepConfirmNumber/ConfirmNumberTwo";
import { ConfirmFinish } from "../../components/ConfirmFinish";

export const StepThree = () => {
  const [stepConfirmNumber, setStepConfirmNumber] = useState(1);

  if (stepConfirmNumber === 2)
    return <ConfirmTwo changeStep={setStepConfirmNumber} />;
  if (stepConfirmNumber === 3) return <ConfirmFinish />;

  return <ConfirmOne changeStep={setStepConfirmNumber} />;
};
